import { Injectable, LOCALE_ID, Inject } from '@angular/core';
import * as moment from 'moment';
import { Moment } from 'moment';

/**Parses date in locale format (ex. en-US MM/DD/YY); formats to same.*/
@Injectable()
export class DateFormatHelper {
  @Inject(LOCALE_ID) private locale;

  private dateFormat: string;
  private validationDateFormat: string;

  constructor() {
    moment.locale(this.locale);
    const localeData = moment.localeData();
    this.dateFormat = localeData.longDateFormat('L');
    this.validationDateFormat = this.dateFormat
                                  .replace('MM', 'M')
                                  .replace('DD', 'D');
  }

  validate(value: string, nullable: boolean): boolean {
    if (!nullable && (!value || this.validate.length === 0)) {
      return false;
    }
    return !value || moment.utc(value, [this.validationDateFormat, this.dateFormat], true).isValid();
  }

  parse(value: string): Moment {
    return this._parseValid(value);
  }

  format(date: Moment): string {
    if (!date) {
      return '';
    }

    return date.format(this.dateFormat);
  }

  private _parseValid(value: string): Moment {
    const date = moment.utc(value, [this.validationDateFormat, this.dateFormat], true);

    return date;
  }
}
